const checkoutPageES = {
    activateTitle: "Activa tu negocio",
    activateSubtitle: "Completa tu suscripción para empezar a aceptar reservas.",
    totalSeats: "Asientos totales",
    staffSeats: "Asientos de personal",
    poweredBy: "Pagos seguros gestionados por Paddle",
    stillThere: "¿Sigues ahí?",
    continue: "Continuar",
    shopLive: "¡Felicidades! Tu negocio ya está en vivo y visible al público.",
    checkoutUnavailable: "No pudimos abrir la ventana de pago seguro. Un bloqueador de anuncios o un problema de red puede estar impidiéndolo; desactívalo e inténtalo de nuevo.",
    retry: "Intentar de nuevo"

};
export default checkoutPageES